<template>
  <va-show-layout>
    <va-show :item="item">
      <v-row justify="center">
        <v-col lg="8">
          <base-material-card>
            <template #heading>
              <div class="display-2">
                {{ title }}
              </div>
            </template>
            <v-card-text>
              <v-row>
                <v-col>
                  <va-field source="id"></va-field>
                  <va-field source="key"></va-field>
                  <va-field source="language"> {{ language }} </va-field>
                  <va-field source="voiceId" label="Narrator"> {{ narrator }} </va-field>
                </v-col>
                <v-col>
                  <template v-if="item">
                    <va-field source="createdAt" type="date" class="mt-0 pt-0">
                      {{ new Date(item.createdAt).toLocaleDateString('en-CA') }}
                    </va-field>
                    <va-field source="lastUpdatedAt" type="date">
                      {{ new Date(item.lastUpdatedAt).toLocaleDateString('en-CA') }}
                    </va-field>
                  </template>
                  <v-row>
                    <v-col><va-field source="state" label="State" type="chip" color="orange"></va-field></v-col>
                    <v-col>
                      <va-field source="sourceType" label="Source Type" type="chip" color="orange"></va-field>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-card-text>
          </base-material-card>
        </v-col>
      </v-row>
    </va-show>
  </va-show-layout>
</template>

<script>
import { defaultLanguages } from '@/foundations/helpers/defaultLanguages';
import mockedNarrators from '@/foundations/helpers/mockedNarrators';

export default {
  props: {
    title: {
      type: String,
      default: '',
    },
    item: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      questions: this.item.content,
      language: defaultLanguages.find((language) => language.value === this.item.language)?.text ?? this.item.language,
      narrator: mockedNarrators.find((narrator) => narrator.value === this.item.voiceId)?.text ?? this.item.voiceId,
    };
  },
};
</script>
